import React, { useState } from 'react'
import MessageThreadsList from '../MessageCenter/MessageThreadsList'
import { MessageThreadModel } from '../../models/MessageCenterModels'
import { messageCenterLandingConfig } from '../../config/MessageCenterConfig'

const MessageCenterLanding = () => {
  const [ conversation, setConversation ] = useState<MessageThreadModel | undefined>(undefined)

  return (
    <div className="widget-container mc-landing-container">
      <div className="header">Message Center</div>
      <div className="body">
        <MessageThreadsList
          config={messageCenterLandingConfig} 
          conversation={conversation}
          setConversation={setConversation}
        />
      </div>
    </div>
  )
}

export default MessageCenterLanding